import { Controller } from "@hotwired/stimulus"

// SSO authentication controller — handles Okta and Azure AD login flows.
// Validates email is present, fetches IDP URL from server, and redirects.
export default class extends Controller {
  static values = { provider: String }

  connect() {
    this._originalHTML = this.element.innerHTML
  }

  authenticate(event) {
    event.preventDefault()

    const emailField = this.element.closest("form")?.querySelector("input[type='email']")
    if (!emailField || !emailField.value.trim()) {
      emailField?.focus()
      emailField?.classList.add("border-danger")
      return
    }

    const email = emailField.value.trim()
    const provider = this.providerValue // "okta" or "azuread"
    const url = `/get_${provider}_tenant_idp?email=${encodeURIComponent(email)}`

    this.element.disabled = true
    this.element.textContent = "Loading..."

    fetch(url, {
      headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" }
    })
      .then(response => response.json())
      .then(data => {
        const idps = data.idps || []
        if (idps.length === 1) {
          const issuerKey = provider === "okta" ? "okta_issuer_url" : "azuread_issuer_url"
          window.location.href = idps[0][issuerKey]
        } else if (idps.length > 1) {
          // TODO: Show tenant selection modal (Step 4)
          this._showError("Multiple SSO providers found. Please contact ConsLog Support.")
          this._reset()
        } else {
          this._showError("No SSO provider found for this email. Contact ConsLog Support.")
          this._reset()
        }
      })
      .catch(() => {
        this._showError("SSO authentication failed. Please try again.")
        this._reset()
      })
  }

  _reset() {
    this.element.disabled = false
    this.element.innerHTML = this._originalHTML
  }

  _showError(message) {
    const form = this.element.closest("form")
    if (!form) return

    // Remove any existing SSO error
    form.querySelector("[data-sso-error]")?.remove()

    const alert = document.createElement("div")
    alert.setAttribute("data-sso-error", "")
    alert.className = "mb-4 px-4 py-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700"
    alert.textContent = message
    form.prepend(alert)
  }
}
